// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"915f3921","225":"c48087f3","376":"cdf6dcf3","383":"ad49040f","403":"c2a57e8c","643":"6f4a27e8","793":"703d0c86"}[chunkId] + ".chunk.js";
};